import { normalSanatizerBRL } from "src/utils/functions";

interface SimpleInterestResults {
  monthlyInterest: number[];
  monthlyAccumulated: number[];
  principal: number;
}

export default function JurosSimplesTable({
  results,
}: {
  results: SimpleInterestResults;
}) {
  return (
    <div className="max-h-[400px] overflow-y-auto m-auto overflow-x-auto">
      <table className="bg-white rounded w-full max-h-[400px] overflow-y-auto">
        <thead className="bg-gray-200 sticky top-0">
          <tr>
            <th className="px-4 py-2 text-center truncate">Mês</th>
            <th className="px-4 py-2 text-center truncate">Juros</th>
            <th className="px-4 py-2 text-center truncate">Total Investido</th>
            <th className="px-4 py-2 text-center truncate">Total Juros</th>
            <th className="px-4 py-2 text-center truncate">Total Acumulado</th>
          </tr>
        </thead>
        <tbody className="max-h-[400px] overflow-y-auto">
          {results.monthlyInterest.map((interest: number, index: number) => (
            <tr className="border-b" key={index}>
              <td className="px-4 py-2 text-center">{index}</td>
              <td className="px-4 py-2 text-center">
                <span className="text-sm mr-1">R$</span>
                {normalSanatizerBRL(interest)}
              </td>
              <td className="px-4 py-2 text-center">
                <span className="text-sm mr-1">R$</span>
                {normalSanatizerBRL(results.principal)}
              </td>
              <td className="px-4 py-2 text-center">
                <span className="text-sm mr-1">R$</span>
                {normalSanatizerBRL(results.monthlyInterest[index])}
              </td>
              <td className="px-4 py-2 text-center">
                <span className="text-sm mr-1">R$</span>
                {normalSanatizerBRL(results.monthlyAccumulated[index])}
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
